import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Button from "../button";
import { ButtonNew } from "../button";
import Parallax from "parallax-js";

const Intro = ({ data }) => {
    const sceneEl = useRef(null);

    useEffect(() => {
        const parallaxInstance = new Parallax(sceneEl.current, {
            relativeInput: true,
        });

        parallaxInstance.enable();

        return () => parallaxInstance.disable();
    }, []);
    return (
        <div className="hero-slider">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="hero-slide-content">
                            <h2 className="animated fa-2x fw-bold">
                                SpeakNest: Make Language Learning a
                                Conversation, Not a Chore.
                            </h2>
                            <p>
                                Connect, converse, and grow your language skills
                                in a judgment-free zone.
                            </p>
                            <ButtonNew
                                classOption="btn btn-lg animated delay1 btn-dark btn-hover-dark me-4 mb-3 mb-sm-0"
                                text="Download Android version"
                                path={`${process.env.PUBLIC_URL}/SpeakNest.apk`}
                            />
                            {/* <a
                                className="btn btn-lg animated delay2 btn-secondary btn-hover-secondary mb-3 mb-sm-0"
                                href="http://38.113.162.155:3000/SpeakNest.apk"
                            >
                                Download SpeakNest
                            </a> */}
                            <br />
                            <Button
                                classOption="btn btn-lg animated delay2 btn-secondary btn-hover-secondary mb-3 mb-sm-0 mt-5"
                                text="Join Us and Elevate Your Language Skills"
                                path="/"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                            className="hero-img scene mt-10 mt-lg-0"
                            id="scene"
                            ref={sceneEl}
                        >
                            <div data-depth="0.2">
                                <img
                                    className="animated"
                                    src={`${process.env.PUBLIC_URL}/${data.image}`}
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Intro.propTypes = {
    data: PropTypes.object,
};

export default Intro;
